
import {nanoid} from 'nanoid'
import Cookies from 'js-cookie'
export default function getDeviceId() {
  let deviceId = Cookies.get('_deviceId') || ''
  if (!deviceId) {
    deviceId = nanoid()
    const url = new window.URL(window.location.href)
    const domains = url.hostname.split('.')
    const topDomain = domains.length >= 2 ? `${domains[domains.length - 2]}.${domains[domains.length - 1]}` : domains[0]
    Cookies.set('_deviceId', deviceId, { domain: topDomain, expires: 365 * 10 })
  }
  return deviceId
}

